module.exports = __webpack_public_path__ + "static/media/location naranja 2.3abba5a9.svg";